import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {InitSummaryPage} from "../init-summary/init-summary";
import {InitWizardProvider} from "../../providers/init-wizard/init-wizard";

/**
 * Generated class for the InitBackpainLevelPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-init-backpain-level',
  templateUrl: 'init-backpain-level.html',
})
export class InitBackpainLevelPage {
  nextHref: any = InitSummaryPage;

  constructor(public navCtrl: NavController, public navParams: NavParams, public initWizard: InitWizardProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InitBackpainLevelPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/init-backpain-level/init-backpain-level.ts